import { CompanyType } from '@@types/api.types';
import Cookies from 'js-cookie';
import { config } from '../config';

export const SELECTED_COMPANY_ID_COOKIE_NAME = 'selectedCompanyId';

const COOKIE_OPTIONS: Cookies.CookieAttributes = {
  expires: 30, // 30 days
  path: '/',
  sameSite: 'Lax',
  secure: config.app.runtimeEnvironment !== 'development',
};

export const getSelectedCompanyId = (): string | null => Cookies.get(SELECTED_COMPANY_ID_COOKIE_NAME) ?? null;

export const setSelectedCompanyId = (companyId: string): string | undefined =>
  Cookies.set(SELECTED_COMPANY_ID_COOKIE_NAME, companyId, COOKIE_OPTIONS);

export const removeSelectedCompanyId = (): void =>
  Cookies.remove(SELECTED_COMPANY_ID_COOKIE_NAME, {
    path: COOKIE_OPTIONS.path,
  });

export const COMPANY_TYPE_LABELS: Record<CompanyType, string> = {
  [CompanyType.COMMERCIAL]: 'Commercial',
  [CompanyType.INTELLIGENCE]: 'Intelligence',
  [CompanyType.RESEARCH]: 'Research',
  [CompanyType.RESEARCH_PROJECT]: 'Research Project',
};

export const getCompanyTypeLabel = (type?: CompanyType): string => {
  if (!type) return '—';
  return COMPANY_TYPE_LABELS[type];
};

export const isResearchType = (type?: CompanyType): boolean =>
  type === CompanyType.RESEARCH || type === CompanyType.RESEARCH_PROJECT;
